import { makeStyles } from '@mui/styles';

const useAccordionBusinessGroupsStyles = makeStyles({
	root: {
		marginBottom: '15px',
		background: 'white',
		width: '90%',
		margin: 'auto',
		maxHeight: '65vh',
		height: 'auto',
		overflowY: 'auto',
		paddingRight: 10,
		scrollbarWidth: 'none',
		'&::-webkit-scrollbar': {
			width: '6px',
			background: '#6868681A',
			borderRadius: 7,
		},
		'&::-webkit-scrollbar-thumb': {
			background: '#68686880',
			borderRadius: 7,
		},
	},
	accordionSummary: {
		width: '100%',
		flexDirection: 'row-reverse',
		margin: 'auto !important',
		border: '1px solid #DEDEDE !important',
		borderRadius: '17px !important',
		padding: '0px !important',
		height: '50px !important',
		minHeight: '50px !important',
	},
	accordionSummaryOpen: {
		width: '100%',
		flexDirection: 'row-reverse',
		margin: 'auto !important',
		border: '1px solid #DEDEDE !important',
		borderRadius: '17px !important',
		padding: '0px !important',
		height: '50px !important',
		minHeight: '50px !important',
		borderBottomLeftRadius: '0px !important',
		borderBottomRightRadius: '0px !important',
	},
	accordion: {
		marginBottom: '10px !important',
		margin: 'auto',
		width: '99%',
		backgroundColor: 'white !important',
	},
	icon: {
		color: '#1063AC',
		margin: '0 10px',
		fontSize: '36px !important',
	},
	title: {
		color: '#1A1233',
		fontSize: '14px !important',
		fontFamily: 'Montserrat !important',
		fontWeight: '600 !important',
		marginTop: '2px !important',
	},
	buttonEdit: {
		position: 'relative',
		marginTop: '-45px',
		marginBottom: 45,
		width: '98%',
	},
	th: {
		fontFamily: 'Montserrat',
		color: '#003C82',
		fontWeight: 'bold',
		textAlign: 'left',
		fontSize: '14px',
	},
	td: {
		color: '#1A1233',
		fontFamily: 'Montserrat',
		fontSize: '14px',
		padding: '10px 0px',
	},
	table: {
		width: '97%',
		margin: 'auto',
		borderCollapse: 'collapse',
	},
	rootTable: {
		maxHeight: 350,
		height: 'auto',
		overflowY: 'auto',
		scrollbarWidth: 'none',
		'&::-webkit-scrollbar': {
			width: '6px',
			background: '#6868681A',
			borderRadius: 7,
		},
		'&::-webkit-scrollbar-thumb': {
			background: '#68686880',
			borderRadius: 7,
		},
	},
	tooltip: {
		fontSize: '10px !important',
		fontFamily: 'Montserrat, Medium',
		backgroundColor: '#686868 !important',
		color: 'white !important',
		borderRadius: '10px !important',
		width: 'auto',
		textAlign: 'center',
		padding: '4px 12px !important',
		marginTop: '-5px !important',
	},
	arrow: {
		color: 'white !important',
	},
});

export default useAccordionBusinessGroupsStyles;
